import { z } from 'zod'
import type { SupplierERPSettings } from '../../models/SupplierERPSettings'
import { BaseCompanyDTO, mapBaseCompanyToDTO, mapDTOToBaseCompany } from '~/domain/shared/company/gateways/DTOs/BaseCompanyDTO'

export const SupplierERPSettingsDTO = z.object({
  enable_new_suppliers_for_all_companies: z.boolean().nullish(),
  companies: z.array(BaseCompanyDTO).nullish(),
  company_ids: z.array(z.number()).nullish()
})

export type SupplierERPSettingsDTO = z.infer<typeof SupplierERPSettingsDTO>

export function mapSupplierERPSettingsToDTO (model: SupplierERPSettings): SupplierERPSettingsDTO {
  return {
    enable_new_suppliers_for_all_companies: model.enableNewSuppliersForAllCompanies,
    company_ids: model.enableNewSuppliersForAllCompanies ? undefined : model.companies.map(company => mapBaseCompanyToDTO(company))
  }
}

export function mapDTOToSupplierERPSettings (dto: SupplierERPSettingsDTO): SupplierERPSettings {
  return {
    enableNewSuppliersForAllCompanies: dto.enable_new_suppliers_for_all_companies ?? false,
    companies: dto.companies?.map(mapDTOToBaseCompany) ?? []
  }
}
